import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'
import { STORE_MAP } from '@/config/cache/cache-engine'

export default {
	getAvailableStaffAndMachineryCards: {
		useCache: true,
		cacheStorage: STORE_MAP.FULL,
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.STAFF_AND_MACHINERY_CARDS]
				.GET_AVAILABLE_STAFF_AND_MACHINERY_CARDS,
	},
	getFullStaffAndMachineryCards: {
		useCache: true,
		cacheStorage: STORE_MAP.FULL,
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.STAFF_AND_MACHINERY_CARDS]
				.GET_AVAILABLE_STAFF_AND_MACHINERY_CARDS,
	},
	getBasedStaffAndMachineryCards: {
		useCache: true,
		cacheStorage: STORE_MAP.BASE,
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.STAFF_AND_MACHINERY_CARDS]
				.GET_AVAILABLE_STAFF_AND_MACHINERY_CARDS,
	},
	getExtendedStaffAndMachineryCards: {
		useCache: true,
		cacheStorage: STORE_MAP.EXTENDED,
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.STAFF_AND_MACHINERY_CARDS]
				.GET_AVAILABLE_STAFF_AND_MACHINERY_CARDS,
	},
}
